import { useEffect, useRef, useState } from "react";

export default function DocumentDownloader({ children, className }) {
  const [signedUrl, setSignedUrl] = useState("");
  const linkRef = useRef();
  const link = <a href={signedUrl} ref={linkRef}></a>;

  useEffect(() => {
    if (signedUrl) {
      linkRef.current.click();
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setSignedUrl("");
    }
    return () => {
      if (signedUrl) {
        // Revoke file URL if it was a local file
        URL.revokeObjectURL(signedUrl);
      }
    };
  }, [signedUrl]);

  return (
    <div className={className}>
      {signedUrl && link}
      {children && children(setSignedUrl)}
    </div>
  );
}
